import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Input } from 'antd';

import CONSTANT from '../../constant';
import { showErrorMessage } from '../../util/index';
import ProjectApi from '../../services/api/project';
import projectModel from '../../model/project.model';
import Emitter from '../../services/emitter';
import ProjectAction from '../../reducers/project/action';
import Subscribe from '../../util/subscribe';

import Save from './save';

class ProjectName extends React.Component {

    state = {
        value: this.props.intlr.messages['FILENAME.EMPTY'],
        isFocusInput: false,
    };

    constructor(props) {
        super(props);
        const obr = value => {
            this.networkStatus = value;
        };
        Subscribe.listen('network', obr);
    }

    componentWillReceiveProps(nextProps) {
        const { project } = nextProps;

        if (this.state.value === project.name || !project.name) return;
        this.setState({
            'value': project.name
        });
    }

    handleRenameChange = (value) => {
        if (_.trim(value).length > 48) {
            showErrorMessage.bind(this)('PROJECT.NAME.MAX.LENGTH.TEXT');
            value = value.substring(0, 48);
        }
        this.setState({ value });
    }

    handlePressEnter = () => {
        this.renameInput.input.blur();
    }

    handleRenameFocus = () => {
        this.setState({ isFocusInput: true });
        this.renameInput.input.select();
    }

    handleRename = (value) => {
        const { project, intlr, confirmName } = this.props;
        const { id, projectStatus, projectType, projectId } = project;
        const createdAt = Date.parse(new Date()) / 1000;
        let name = _.trim(value);

        this.setState({
            isFocusInput: false
        });

        if (this.networkStatus === 'offline' && projectType === 'list') {
            this.setState({
                value: project.name || ProjectApi.getNewProjectName(intlr.messages['FILENAME.EMPTY'], project.projects)
            });
            showErrorMessage.bind(this)('MSG.99999');
            return;
        }

        if (name === project.name) return;

        if (_.isEmpty(name)) {
            showErrorMessage.bind(this)('RENAME.ERR.NULL.MSG');
            return this.setState({
                value: project.name || ProjectApi.getNewProjectName(intlr.messages['FILENAME.EMPTY'], project.projects)
            });
        }

        name = ProjectApi.getNewProjectName(name, project.projects);
        this.setState({
            value: name
        });
        projectModel.reName(name);
        confirmName(true);
        Emitter.emit('RenameProject', { id, projectName: name, createdAt, projectId, syncStatus: projectStatus }, 'web');
    }

    projectName = () => {
        const { project } = this.props;
        const { name, projectStatus, showLoadingPage, saveStatus } = project;
        const { value } = this.state;
        const isDisabled = project.isForThirdPlatform || (projectStatus === CONSTANT.PROJECT_STATUS.WILL_DOWNLOAD ||
            showLoadingPage || saveStatus === CONSTANT.PROJECT_SAVE_STATUS.DOING);
        return (
            <Input className="input-rename"
                ref={rinput => this.renameInput = rinput}
                defaultValue={name}
                value={value}
                disabled={isDisabled}
                onChange={e => this.handleRenameChange(e.target.value)}
                onPressEnter={this.handlePressEnter.bind(this)}
                onClick={this.handleRenameFocus.bind(this)}
                onBlur={e => this.handleRename(e.target.value)}
                autoComplete="off" />
        );
    }

    saveMessage() {
        const { intlr, project } = this.props;
        const { saveStatus } = project;
        switch (saveStatus) {
            case CONSTANT.PROJECT_SAVE_STATUS.SUCCESS:
                return (<span className="editor-header-save-success">{intlr.messages['MENU.FILE.SAVE.SUCCESS']}</span>);
            case CONSTANT.PROJECT_SAVE_STATUS.FAILURE:
                return (<span className="editor-header-save-failure">{intlr.messages['MENU.FILE.SAVE.FAIL']}</span>);
            case CONSTANT.PROJECT_SAVE_STATUS.DOING:
                return (<span className="editor-header-saving">{intlr.messages['MENU.FILE.SAVEING']}</span>);
            default:
                return '';
        }
    }

    render() {
        const { isFocusInput, value } = this.state;
        const props = {
            value,
            isFocusInput
        };

        return (
            <section className="header-cell project-name-cell">
                {this.projectName()}
                {
                    this.props.project.isForThirdPlatform ? null : <Save { ...props } />
                }
            </section>
        );
    }
}

export default connect(state => ({
    project: state.project,
    intlr: state.intlr,
    account: state.account
}), dispatch => ({
    confirmName: isConfirmName => dispatch(ProjectAction.saved({isConfirmName}))
}))(ProjectName);